// Blog index metadata. Individual posts still render from markdown
// (see md2html.sh / src/assets/generated/*.<locale>.html); this list only
// drives the index page (title, date, icon per post, per locale).
// The list itself is public/posts.json: it is also served as
// https://www.celp.de/posts.json, so stats.g1 (ansible-celp playbook/stats/)
// knows which paths are blog posts. Add new posts there.
import posts from '../../public/posts.json'

export default posts
